import { useEffect } from "react";
import { Outlet } from "react-router";
import { useMutation } from "@tanstack/react-query";
import { SettingsService } from "../../../services/api";
import { useGlobalContext } from "../../../stores/Global";
import useRefresh from "../../../hooks/useRefresh";

export default function SettingsLayout() {
  const { context, setContext } = useGlobalContext();

  const { mutate: loadSettings } = useMutation({
    mutationFn: async () => {
      const res = await SettingsService.getSettings();
      if (!res?.data?.data) return;
      return res.data.data;
    },
    mutationKey: ["settings"],
    onSuccess: (data) => {
      // Partial update: the reducer merges, so we don't clobber user
      // (or anything else) that a concurrent loader set in the meantime.
      setContext({ settings: data });
    },
  });

  useEffect(() => {
    loadSettings();
  }, []);

  useRefresh(loadSettings);

  return <Outlet />;
}